<template>
    <!-- カテゴリー見出しパーツ-->
    <div id="pt080" class="pt080">
        <div class="categoryMain">
            <!--カテゴリ見出しタイトル-->
            <h2 v-if="categoryEntry.categoryHdrTitle != undefined && categoryEntry.categoryHdrTitle != null" class="categoryTitle">{{categoryEntry.categoryHdrTitle}}</h2>
            <!--カテゴリ見出し説明-->
            <div v-if="categoryEntry.categoryHdrDisp != undefined && categoryEntry.categoryHdrDisp != null" class="categoryDisp">
                <span v-html="categoryEntry.categoryHdrDisp">
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "assets/js/request";
import common from "assets/js/common";

export default {
    name: "PT080CategoryHeadlineParts",
    components:{
        common
    },
    data() {
        return {
            pt080ReqModel:{

            },
            categoryEntry:{
                categoryHdrTitle : null,
                categoryHdrDisp  : null
            },
            site: ""
        }
    },
    mounted() {
        var _this = this;
        //debugger;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT080 + _this.$UrlConstants.DO_INIT, _this.pt080ReqModel).then(function(response) {
            //set data init
            if(response.data.categoryList[0] !=undefined){
                _this.categoryEntry.categoryHdrTitle = response.data.categoryList[0].HDR_TITLE;
                _this.categoryEntry.categoryHdrDisp = response.data.categoryList[0].HDR_DISP;
            } else {
                _this.categoryEntry.categoryHdrTitle = "";
                _this.categoryEntry.categoryHdrDisp = "";
            }
            

        }).catch(function(error) {
            common.errorAPI(error);
        });
    },
    methods: {
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        /**
         * Reload page
         */
        reload: function() {
            this.$router.go(0);
        },
    },
    created(){
        var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = _this.$route.query;

        if(Object.keys(paramData).length > 0){
            _this.pt080ReqModel = Object.assign({}, _this.pt080ReqModel, paramData);
        }

        if(Object.keys(queryData).length > 0){
            _this.pt080ReqModel = Object.assign({}, _this.pt080ReqModel, queryData);
        }
    },
}
</script>
